export default "__VITE_ASSET__mgO_FCzS__"